import React, { useEffect, useState } from 'react'
import { Breadcrumb } from '../../Components/Atoms';
import { AddModelIcon } from '../../Assets/images/svgs';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@chakra-ui/react';
import { ReactTable } from '../../Components/Molecules';
import { SHOW_BATTERY_HEADERS } from '../../Library/tableHeaders';
import './style.css';
import { getFilters } from '../../Library/tableHelpers';
import PATH from '../../Routes/paths';
import { getBatteriesData } from '../../APIs';
import { CONNECTOR_TYP_REV_MAP } from '../../Library/constants';

const ShowBatteries = () => {
  const Navigate = useNavigate();
  const [data, setData] = useState([]);

  const columns = React.useMemo(() =>
    Object.values(SHOW_BATTERY_HEADERS).map(header => {
      return {
        Header: header.nm,
        accessor: header.key,
        disableSortBy: !header.sorting,
        ...getFilters(header),
        Cell: (row) => {
          if (row.column.id === "bId")
            return <Link to={`${row.value}`} className='show-battery-bid-col'>{row.value || '-'}</Link>;
          else 
            return row.value;
        },
      };
    }), []);


  const fetchBatteries = async () => {
    const btryData = await getBatteriesData();
    if (btryData) {
      let processedBatteryData = btryData.map(data => {
        let btyData =  {...data};
        btyData["ampHrs"] = btyData["ampHrs"]+' Ah';
        btyData["vltg"]   = btyData["vltg"]+'V';
        btyData["cTyp"]   = CONNECTOR_TYP_REV_MAP[btyData["cTyp"]];
        
        return btyData;
      })
      setData(processedBatteryData);
    };
  };

  useEffect(() => {
    fetchBatteries();
  }, []);

  const breadcrumbPaths = [
    { idx: 1, name: "Inventory Management", link: PATH.INVENTORY },
    { idx: 1, name: "Batteries", link: "", isCurrentPage: true },
  ]
  return (
    <div className="panel-main show-battery-main">
      <div>
        <Breadcrumb paths={breadcrumbPaths} />
      </div>

      <div className='show-battery-section'>
        <Button
          leftIcon={<AddModelIcon />}
          className="add-new-battery-btn"
          onClick={() => Navigate("addbattery")}
        >
          Add New Battery
        </Button>

        <div className='show-battery-table'>
          <ReactTable
            heading={"Battery"}
            columns={columns}
            data={data}
            showSearch={true}
            pageSize={6}
          />
        </div>
      </div>
    </div>
  )
}

export default ShowBatteries;